import { lazy, Suspense, useState } from 'react'
import { ClipboardList, LoaderCircle } from 'lucide-react'
import { useFeatureSelector } from '@/platform/state/hooks'
import { hasPermission } from '@/platform/authorization/permissions'

const PersonalOrdersDrawer = lazy(() => import('./PersonalOrdersDrawer'))

export function PersonalOrdersButton() {
  const [open, setOpen] = useState(false)
  const [openedOnce, setOpenedOnce] = useState(false)
  const [openVersion, setOpenVersion] = useState(0)
  const user = useFeatureSelector((state) => state.session.user)
  const authorization = useFeatureSelector((state) => state.session.authorization)
  if (!user || !hasPermission(authorization, 'orders')) return null

  return <>
    <button type="button" onClick={() => { if (open) setOpen(false); else { setOpenedOnce(true); setOpenVersion((value) => value + 1); setOpen(true) } }} aria-label="Đơn hàng của tôi" title="Đơn hàng" aria-expanded={open} className="relative z-10 grid h-10 w-10 shrink-0 place-items-center rounded-lg border border-orange-200 bg-orange-50 text-orange-700 transition hover:border-orange-300 hover:bg-orange-100">
      <ClipboardList size={19} />
    </button>
    {openedOnce && <Suspense fallback={open ? <span className="fixed inset-0 z-[150] grid place-items-center bg-slate-950/25"><LoaderCircle className="animate-spin text-orange-600" /></span> : null}>
      <PersonalOrdersDrawer open={open} openVersion={openVersion} onClose={() => setOpen(false)} />
    </Suspense>}
  </>
}
